import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { PublicPage } from "src/layout/PublicPage";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_public/reset-password")({
  component: RouteComponent,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      if (ctx.session?.user) {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});

function RouteComponent() {
  return (
    <PublicPage contentClassName="bg-accent">
      <Outlet />
    </PublicPage>
  );
}
